import React, { useState,useEffect } from 'react';
import { toast } from 'react-toastify';
import {format } from 'date-fns';
import { getDefaultReviewList,getSingleReviewTemplateDetail,searchG2BusinessReview } from "../../../../utils/reviewApi";
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import RatingStars from "../../../../components/RatingStars";

const BadgeWidget = ({selectedLayout,isTemplateId, widgetId,reviewTabData,searchedKeyword}) => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [expandedReviewId, setExpandedReviewId] = useState(null);

  // Default values for the reviewTabData
  const {
      is_website_frontend,
      business_name,
      style_background_color,
      header_is_widget_title,
      header_title,
      header_caption,
      setting_rating_format,
      style_widget_title_color,
      style_widget_title_fonts_title_size,
      style_widget_title_caption_color,
      style_widget_title_fonts_caption_size,
      style_header_background_color,
      header_is_show_header,
      header_write_reviews_button,
      header_source_icon,
      header_rating,
      header_number_of_reviews,
      style_header_text_color,
      style_header_write_review_background_color,
      style_header_write_review_text_color,
      header_write_review_button_type,
      style_rating_stars_color,
      style_load_more_button_color,
      style_load_more_button_text_color,
  } = reviewTabData || {};

  //Handle when clicking "Read More"
  const handleReadMoreClick = (review) => {
    setExpandedReviewId(prev =>
      prev === review.id ? null : review.id
    );
  };

  //Handle Main Popup
  const togglePopup = () => {
      setShowPopup(!showPopup);
  };

  // Load More function
  const handleLoadMore = () => {
      setVisibleCount((prevCount) => prevCount + 5);
  };

  // Fetching Review data
  useEffect(() => {
      const fetchData = async () => {
          setLoading(true);
          try {
              let result;
              if (isTemplateId) {
                  result = await getSingleReviewTemplateDetail(isTemplateId);
              } else if (widgetId) {
                  result = await getSingleWidgetDetail(widgetId);
              } else if (business_name) {
                const payload = { business_name: business_name };
                result = await searchG2BusinessReview(payload);
              } else {
                  let app_type = 'G2_Review';
                  result = await getDefaultReviewList(app_type);
              }
              setApiData(result);
          } catch (error) {
              toast.warning(error.message);
          } finally {
              setLoading(false); 
          }
      };

      fetchData();
  }, [isTemplateId, widgetId, business_name]);
  return (
   <>
    <div className={`upgadeify-review-template-widget upgadeify-badge-style ${showPopup ? 'main-popup-open' : ''} ${is_website_frontend}`}>
        {/* Loader and No Api Data Handling */}
        {loading ? (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading please wait...</p>
            </div>
        ) : apiData?.status === true ? (
        <>
          <div className='upgadeify-badge-style-header' onClick={togglePopup}>
            <div className='upgadeify-badge-header-title'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><path fill="#FF492C" fill-rule="evenodd" d="M12.294 2.5c.656.034 1.312.083 1.96.192-.673 1.368-1.337 2.739-2.014 4.104a5.85 5.85 0 0 0-3.756 1.336 5.699 5.699 0 0 0-2.015 3.421c-.221 1.382.06 2.846.846 4.022.867 1.35 2.34 2.302 3.946 2.568a6.01 6.01 0 0 0 4.805-1.302c.734 1.25 1.471 2.5 2.213 3.745-1.95 1.398-4.42 2.074-6.83 1.882a10.227 10.227 0 0 1-6.442-2.894 9.851 9.851 0 0 1-2.896-5.68A18.008 18.008 0 0 1 2 12.37v-.32c.068-.677.134-1.359.32-2.016.684-2.675 2.57-5.022 5.057-6.324 1.474-.79 3.15-1.18 4.828-1.21h.09Zm7.146 8.639c.825 1.4 1.642 2.803 2.486 4.192l.074.087v.06l-.073.087c-.842 1.397-1.66 2.807-2.497 4.208-.845-1.446-1.703-2.884-2.554-4.326-1.703.001-3.406-.002-5.109.002.848-1.437 1.705-2.868 2.544-4.31 1.71-.004 3.42-.003 5.129 0Zm-.304-7.11c.737.642.697 1.883.005 2.542-.566.576-1.382.797-2.047 1.233-.273.17-.427.455-.53.743 1.025.013 2.05.006 3.076.004.005.407.003.815.003 1.222a1018.97 1018.97 0 0 0-4.613 0c-.024-.784.098-1.617.59-2.264.482-.632 1.219-1.007 1.931-1.346.32-.164.7-.389.745-.772.051-.28-.124-.565-.39-.674-.431-.18-.949-.102-1.34.138-.295.18-.487.473-.663.758-.291-.285-.583-.57-.88-.848.392-.752 1.206-1.283 2.073-1.344.724-.061 1.5.116 2.04.608Z" clip-rule="evenodd"></path></svg>

              <div className='upgadeify-badge-reviews-header-title-text'>G2 Bussiness Rating</div>
            </div>
            <div className='upgadeify-g2-reviews-header-rating'>
              <div className="upgadeify-g2-reviews-header-rating-text">{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
              <div className="upgadeify-g2-reviews-item-rating">
                <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
              </div>
            </div>
            <div className="upgadeify-badge-reviews-readmore">
              Read our { apiData.data.total_reviews }  reviews
            </div>
          </div>
        </>
          ) : (
              <div className="no-inner-result-found">
                  <p>No G2 reviews found please check the url.</p>
              </div>
          )}
        </div>
    
        {showPopup && (
        <div className="upgadeify-badge-fixed-style">
          <div className="upgadeify-badge-style-inner" style={{backgroundColor: style_background_color}}>
              <button className="upgadeify-badge-fixed-style-close" onClick={togglePopup}>X</button>
              {Number(header_is_widget_title) === 1 && (
                <>
                  <div className="upgadeify-badge-fixed-style-title">
                      <h2 style={{ color: style_widget_title_color,fontSize: style_widget_title_fonts_title_size }}>{header_title || ""}</h2>
                      <h2 style={{ color: style_widget_title_caption_color,fontSize: style_widget_title_fonts_caption_size }}>{header_caption || ""}</h2>
                  </div>
                </>
              )}
              {Number(header_is_show_header) === 1 &&
                (Number(header_source_icon) === 1 ||
                    Number(header_rating) === 1 ||
                    Number(header_number_of_reviews) === 1 ||
                    Number(header_write_reviews_button) === 1) && (
               <div className="upgadeify-badge-fixed-style-header" style={{ backgroundColor: style_header_background_color,}}>
                    <div className='upgadeify-g2-reviews-header-left'>
                      {Number(header_source_icon) === 1 && (
                        <div className='upgadeify-g2-reviews-header-title'>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><path fill="#FF492C" fill-rule="evenodd" d="M12.294 2.5c.656.034 1.312.083 1.96.192-.673 1.368-1.337 2.739-2.014 4.104a5.85 5.85 0 0 0-3.756 1.336 5.699 5.699 0 0 0-2.015 3.421c-.221 1.382.06 2.846.846 4.022.867 1.35 2.34 2.302 3.946 2.568a6.01 6.01 0 0 0 4.805-1.302c.734 1.25 1.471 2.5 2.213 3.745-1.95 1.398-4.42 2.074-6.83 1.882a10.227 10.227 0 0 1-6.442-2.894 9.851 9.851 0 0 1-2.896-5.68A18.008 18.008 0 0 1 2 12.37v-.32c.068-.677.134-1.359.32-2.016.684-2.675 2.57-5.022 5.057-6.324 1.474-.79 3.15-1.18 4.828-1.21h.09Zm7.146 8.639c.825 1.4 1.642 2.803 2.486 4.192l.074.087v.06l-.073.087c-.842 1.397-1.66 2.807-2.497 4.208-.845-1.446-1.703-2.884-2.554-4.326-1.703.001-3.406-.002-5.109.002.848-1.437 1.705-2.868 2.544-4.31 1.71-.004 3.42-.003 5.129 0Zm-.304-7.11c.737.642.697 1.883.005 2.542-.566.576-1.382.797-2.047 1.233-.273.17-.427.455-.53.743 1.025.013 2.05.006 3.076.004.005.407.003.815.003 1.222a1018.97 1018.97 0 0 0-4.613 0c-.024-.784.098-1.617.59-2.264.482-.632 1.219-1.007 1.931-1.346.32-.164.7-.389.745-.772.051-.28-.124-.565-.39-.674-.431-.18-.949-.102-1.34.138-.295.18-.487.473-.663.758-.291-.285-.583-.57-.88-.848.392-.752 1.206-1.283 2.073-1.344.724-.061 1.5.116 2.04.608Z" clip-rule="evenodd"></path></svg>
                              <div className='upgadeify-g2-reviews-header-title-text' style={{color: style_header_text_color,}}>Reviews</div>
                        </div>
                        )}
                        <div className='upgadeify-g2-reviews-header-rating'>
                          {Number(header_rating) === 1 && (
                          <>
                              <div className="upgadeify-g2-reviews-header-rating-text" style={{color: style_header_text_color,}}>{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
                              <div className="upgadeify-g2-reviews-item-rating">
                                  <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
                              </div>
                          </>
                          )}
                          {Number(header_number_of_reviews) === 1 && (
                              <span className="upgadeify-g2-reviews-header-number-of-reviews-text">({apiData.data.total_reviews})</span>
                          )}
                        </div>
                    </div>
                    {Number(header_write_reviews_button) === 1 && (
                        <div className='upgadeify-alieyelpxpress-reviews-header-right'>
                            <a
                                href={apiData?.data?.google_url?.startsWith('http') ? apiData.data.google_url : `https://${apiData.data.google_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className='upgadeify-g2-reviews-header-button'
                                style={{color: style_header_write_review_text_color,backgroundColor: style_header_write_review_background_color,fontSize: header_write_review_button_type}}>Review us on G2
                            </a>
                        </div>
                    )}
                </div>
              )}
              {/* Reviews List */}
              {apiData.data.review_list.slice(0, visibleCount).map((review) => (
                  <ReviewLoopItem key={review.id} review={review} handleReadMoreClick={handleReadMoreClick} reviewTabData={reviewTabData} expandedReviewId={expandedReviewId}/>
              ))}
              {/* Load More Button  */}
              {visibleCount < apiData.data.review_list.length && (
                <div className="load-more-button">
                    <button onClick={handleLoadMore} style={{backgroundColor: style_load_more_button_color,color: style_load_more_button_text_color}}>Load More</button>
                </div>
              )}
          </div>
        </div>
      )}
   </>
  );
};

const ReviewLoopItem = ({ review, handleReadMoreClick, reviewTabData, expandedReviewId }) => (
    <>
        <div className="upgadeify-g2-reviews">
            <div className='upgadeify-g2-reviews-item' style={{ padding: `${reviewTabData.layout_item_spacing}px`, backgroundColor: reviewTabData.style_review_background_color,}}>
               <div className='upgadeify-g2-reviews-head'>
                {Number(reviewTabData.review_is_show_reviewer_picture) === 1 && (
                    <div className="upgadeify-g2-reviews-item-image">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}

                       
                    </div>
                )}
                <div className='upgadeify-g2-reviews-item-name'>
                    {Number(reviewTabData.review_is_show_reviewer_name) === 1 && (
                        Number(reviewTabData.setting_is_enable_external_links) === 1 && review.author_url ? ( 
                            <a
                                href={review.author_url} 
                                target={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "_blank" : "_self"}
                                rel={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "noopener noreferrer" : undefined}
                                style={{ color: reviewTabData.style_review_reviewer_name_color }}
                            >
                                <span className="upgadeify-g2-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>{review.name}</span>
                            </a>
                        ) : (
                            <span className="upgadeify-g2-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>
                                {review.name}
                            </span>
                        )
                    )}

                    {Number(reviewTabData.review_is_show_verified_badge) === 1 && (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="review-verified-badge-icon" aria-hidden="true">
                            <path fill={reviewTabData.style_review_verified_badge_color} d="M6.757.236a.35.35 0 0 1 .486 0l1.106 1.07a.35.35 0 0 0 .329.089l1.493-.375a.35.35 0 0 1 .422.244l.422 1.48a.35.35 0 0 0 .24.24l1.481.423a.35.35 0 0 1 .244.422l-.375 1.493a.35.35 0 0 0 .088.329l1.071 1.106a.35.35 0 0 1 0 .486l-1.07 1.106a.35.35 0 0 0-.089.329l.375 1.493a.35.35 0 0 1-.244.422l-1.48.422a.35.35 0 0 0-.24.24l-.423 1.481a.35.35 0 0 1-.422.244l-1.493-.375a.35.35 0 0 0-.329.088l-1.106 1.071a.35.35 0 0 1-.486 0l-1.106-1.07a.35.35 0 0 0-.329-.089l-1.493.375a.35.35 0 0 1-.422-.244l-.422-1.48a.35.35 0 0 0-.24-.24l-1.481-.423a.35.35 0 0 1-.244-.422l.375-1.493a.35.35 0 0 0-.088-.329L.236 7.243a.35.35 0 0 1 0-.486l1.07-1.106a.35.35 0 0 0 .089-.329L1.02 3.829a.35.35 0 0 1 .244-.422l1.48-.422a.35.35 0 0 0 .24-.24l.423-1.481a.35.35 0 0 1 .422-.244l1.493.375a.35.35 0 0 0 .329-.088L6.757.236Z"></path><path fill="#fff" fill-rule="evenodd" d="M9.065 4.85a.644.644 0 0 1 .899 0 .615.615 0 0 1 .053.823l-.053.059L6.48 9.15a.645.645 0 0 1-.84.052l-.06-.052-1.66-1.527a.616.616 0 0 1 0-.882.645.645 0 0 1 .84-.052l.06.052 1.21 1.086 3.034-2.978Z" clip-rule="evenodd"></path>
                        </svg>
                    )}

                    <span className="upgadeify-g2-reviews-item-date"> 
                        {Number(reviewTabData.review_is_show_date) === 1 && (
                            <span style={{color: reviewTabData.style_review_date_color,}}>{review.review_date ? format(new Date(review.review_date), 'yyyy-MM-dd') : ''}</span>
                        )}
                    </span>
                </div>
               </div>
                <div className="upgadeify-g2-reviews-item-content">
                    {Number(reviewTabData.review_is_show_rating) === 1 && (
                        <span className="upgadeify-g2-reviews-item-rating" style={{ fontSize: reviewTabData.style_review_rating_size }}>
                            <RatingStars average_rating={review.rating} newColor={reviewTabData.style_rating_stars_color}/>
                        </span>
                    )}
                    <div className="upgadeify-g2-reviews-item-text" style={{color: `${reviewTabData.style_review_text_color}`,fontSize: reviewTabData.style_review_text_font_size}}>
                        {expandedReviewId === review.id ? review.description: review.description.length > 50
                            ? `${review.description.slice(0, 50)}...`
                            : review.description
                        }
                    </div>
                    {review.description.length > 50 && (
                      <div className="upgadeify-g2-reviews-readmore" onClick={() => handleReadMoreClick(review)}
                        style={{
                          color: reviewTabData.style_read_more_color,
                          fontSize: reviewTabData.style_review_text_font_size
                        }}
                      >
                        {expandedReviewId === review.id ? 'Read less' : 'Read more'}
                      </div>
                    )}
                    {Number(reviewTabData.review_is_show_review_source) === 1 && (  
                        <div className='upgadeify-g2-reviews-item-image-badge'>
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><path fill="#FF492C" fill-rule="evenodd" d="M12.294 2.5c.656.034 1.312.083 1.96.192-.673 1.368-1.337 2.739-2.014 4.104a5.85 5.85 0 0 0-3.756 1.336 5.699 5.699 0 0 0-2.015 3.421c-.221 1.382.06 2.846.846 4.022.867 1.35 2.34 2.302 3.946 2.568a6.01 6.01 0 0 0 4.805-1.302c.734 1.25 1.471 2.5 2.213 3.745-1.95 1.398-4.42 2.074-6.83 1.882a10.227 10.227 0 0 1-6.442-2.894 9.851 9.851 0 0 1-2.896-5.68A18.008 18.008 0 0 1 2 12.37v-.32c.068-.677.134-1.359.32-2.016.684-2.675 2.57-5.022 5.057-6.324 1.474-.79 3.15-1.18 4.828-1.21h.09Zm7.146 8.639c.825 1.4 1.642 2.803 2.486 4.192l.074.087v.06l-.073.087c-.842 1.397-1.66 2.807-2.497 4.208-.845-1.446-1.703-2.884-2.554-4.326-1.703.001-3.406-.002-5.109.002.848-1.437 1.705-2.868 2.544-4.31 1.71-.004 3.42-.003 5.129 0Zm-.304-7.11c.737.642.697 1.883.005 2.542-.566.576-1.382.797-2.047 1.233-.273.17-.427.455-.53.743 1.025.013 2.05.006 3.076.004.005.407.003.815.003 1.222a1018.97 1018.97 0 0 0-4.613 0c-.024-.784.098-1.617.59-2.264.482-.632 1.219-1.007 1.931-1.346.32-.164.7-.389.745-.772.051-.28-.124-.565-.39-.674-.431-.18-.949-.102-1.34.138-.295.18-.487.473-.663.758-.291-.285-.583-.57-.88-.848.392-.752 1.206-1.283 2.073-1.344.724-.061 1.5.116 2.04.608Z" clip-rule="evenodd"></path></svg>
                            Posted On   
                            <> <a href={`https://www.g2.com`} target="blank">G2</a></> 
                        </div> 
                    )} 
                </div>
            </div>
        </div>
    </>
);

export default BadgeWidget;
